import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withApollo } from "react-apollo";
import { push } from 'connected-react-router';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

import EditorForm from './components/EditorForm';

import { parseFormErrors } from '../shared/utils/form_errors';
import { AdminsAndEditorsQuery, CreateAdminMutation, CreateEditorMutation } from './queries';

class NewEditor extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(data) {
    const { client, push } = this.props;
    return client.query({
      query: AdminsAndEditorsQuery, variables: {
        filter: { "email":  data.email }
      }
    })
      .then(res => {
        if (res.data.Users.length === 0) {
          throw new Error('User with given email not found');
        }
        return res.data.Users[0];
      })
      .then(user => {
        const mutation = data.role === 'admin' ? CreateAdminMutation : CreateEditorMutation;
        return client.mutate({
          mutation,
          variables: { userId: user._id },
        })
          .then(() => push('/editors'));
      })
      .catch(parseFormErrors);
  }

  render() {
    return (
      <div id="new-editor">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/editors">Editors</Link></Breadcrumb.Item>
          <Breadcrumb.Item>New Editor</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <EditorForm onSubmit={this.handleSubmit} />
        </div>
      </div>
    );
  }
}

export default compose(
  connect(null, { push }),
  withApollo,
)(NewEditor);
